export default __webpack_public_path__ + "static/media/structures-mob.221dee84.png";